import { useTranslation } from 'react-i18next';
import { FieldItem } from '@lib/interfaces/form';
import MonitoringFilterFieldNames from '@lib/enums/fieldNames/monitoringFilterFieldNames';
import {
  getFieldValidation,
  getOptionsArrayValidation,
} from '@lib/utils/validationUtils';
import Input from '@lib/components/Input/Input';
import CheckBoxGroup from '@lib/components/CheckBoxGroup/CheckBoxGroup';
import { FilterPresetType, MonitoringEntity } from '../enums';

export const DASHBOARD_MONITORING_FILTER_CREATE_FORM_VALUES = {
  [MonitoringFilterFieldNames.Name]: null,
  [MonitoringFilterFieldNames.FilterPresetConfig]: [],
};

export default function useFilterPresetFields({
  monitoringEntity,
}: {
  monitoringEntity: MonitoringEntity;
}): FieldItem[] {
  const { t } = useTranslation();
  let rangesLabel = '';
  if (monitoringEntity === MonitoringEntity.Site) {
    rangesLabel = t('sites-ranges');
  } else if (monitoringEntity === MonitoringEntity.Sector) {
    rangesLabel = t('sectors-ranges');
  }
  return [
    {
      name: MonitoringFilterFieldNames.Name,
      label: t('view-name'),
      element: Input,
      validation: getFieldValidation({ t, required: true }),
    },
    {
      name: MonitoringFilterFieldNames.FilterPresetConfig,
      element: CheckBoxGroup,
      validation: getOptionsArrayValidation({ required: true, t }),
      componentProps: {
        label: t('include-in-preset'),
        options: [
          { label: t('filters'), value: FilterPresetType.Filters },
          { label: t('period'), value: FilterPresetType.Period },
          {
            label: rangesLabel,
            value: FilterPresetType.Ranges,
          },
          { label: t('map-legends'), value: FilterPresetType.MapLegends },
        ],
      },
    },
  ];
}
